import { range } from 'lodash';
import HALLMARK_HOLIDAY_TYPE_MAP from './../../hallmarkHolidayTypeMap';
import MONTHS_MAP from './../../monthsMap';
import DAYS_OF_WEEK_MAP from './../../daysOfWeekMap';

export default {
  name: 'hallmarkHoliday',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'hallmarkHolidays',
    readOne: 'hallmarkHoliday',
    create: 'createHallmarkHoliday',
    update: 'updateHallmarkHoliday',
    // delete: 'deleteHallmarkHoliday',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Tag Question',
      type: 'object',
      required: [
        'title',
        'type',
      ],
      properties: {
        title: {
          type: 'string',
        },
        content: {
          type: 'string',
        },
        type: {
          type: 'string',
          enum: Object.keys(HALLMARK_HOLIDAY_TYPE_MAP),
          enumNames: Object.values(HALLMARK_HOLIDAY_TYPE_MAP),
        },
        monthAndDay: {
          type: 'object',
          properties: {
            month: {
              type: 'number',
              enum: Object.keys(MONTHS_MAP).map(Number),
              enumNames: Object.values(MONTHS_MAP),
            },
            dayOfMonth: {
              type: 'number',
              enum: range(1, 32),
            },
          },
        },
        monthOccurrenceAndDayOfWeek: {
          type: 'object',
          properties: {
            month: {
              type: 'number',
              enum: Object.keys(MONTHS_MAP).map(Number),
              enumNames: Object.values(MONTHS_MAP),
            },
            occurrence: {
              title: '',
              type: 'number',
              enum: [
                0, 1, 2, 3, 4, 5,
              ],
              enumNames: [
                '1st',
                '2nd',
                '3rd',
                '4th',
                '5th',
                '6th',
              ],
            },
            dayOfWeek: {
              type: 'number',
              enum: Object.keys(DAYS_OF_WEEK_MAP).map(Number),
              enumNames: Object.values(DAYS_OF_WEEK_MAP),
            },
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/hallmarkHoliday.js